import { render } from "./makeRequestModal.vue?vue&type=template&id=33725a48"
import script from "./makeRequestModal.vue?vue&type=script&lang=js"
export * from "./makeRequestModal.vue?vue&type=script&lang=js"

import "./makeRequestModal.vue?vue&type=style&index=0&id=33725a48&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__